import { getEnv } from "@/env";

const commerceUrlBase = getEnv("NEXT_PUBLIC_COMMERCE_COORDINATOR_BASE_URL");

/**
 * Get the Coordinator base url.
 *
 * It is generally preferred to `use useBuildCommerceUrl` instead.
 *
 * @param fallbackUrl
 */
export function getCommerceUrlBase(fallbackUrl = ""): string {
  return commerceUrlBase || fallbackUrl;
}
